import React, { useState, useEffect } from "react";
import { Col, Row, Collapse, Container, NavbarToggler } from "reactstrap";
import { Link } from "react-router-dom";
import logodark from "../../assets/images/logo.png";

const Navbar = () => {
    const [isOpenMenu, setIsOpenMenu] = useState(false);
    const [navClass, setNavClass] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setIsOpenMenu(!isOpenMenu);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);
        return () => {
            window.removeEventListener("scroll", scrollNavigation, true);
        };
    }, []);

    const scrollNavigation = () => {
        var scrollup = document.documentElement.scrollTop;
        setNavClass(scrollup > 50 ? "is-sticky" : "");
    };

    const handleNavClick = () => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        setIsOpenMenu(false); 
        setDropdownOpen(false); 
    };

    return (
        <React.Fragment>
            <nav className={`bg-light navbar navbar-expand-lg navbar-landing fixed-top ${navClass}`} id="navbar">
                <Container>
                    <Link className="navbar-brand" to="/landing">
                        <img src={logodark} className="card-logo card-logo-dark" alt="logo dark" height="60" />
                    </Link>
                    <NavbarToggler className="navbar-toggler py-0 fs-20 text-body" onClick={toggle}>
                        <i className="mdi mdi-menu"></i>
                    </NavbarToggler>
                    <Collapse isOpen={isOpenMenu} className="navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav mx-auto mt-2 mt-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link fs-18 fw-bold" to="/landing" onClick={handleNavClick}>Home</Link>
                            </li>

                            {/* Dropdown for Services */}
                            <li className={`nav-item dropdown ${dropdownOpen ? "show" : ""}`}>
                                <button
                                    className="nav-link dropdown-toggle fs-18 fw-bold"
                                    onClick={toggleDropdown}
                                    style={{ background: "none", border: "none", outline: "none", cursor: "pointer" }}
                                >
                                    Services
                                </button>
                                <ul className={`dropdown-menu ${dropdownOpen ? "show" : ""}`} style={{ backgroundColor: "rgb(52, 81, 159)" }}>
                                    {[
                                        { path: "/services/tatamachine", label: "Tata Coffee Machine" },
                                        { path: "/services/nescafemachine", label: "Nescafé Vending Machine" },
                                        { path: "/services/snacksmachine", label: "Snack Vending Machine" },
                                        { path: "/services/sanitorymachine", label: "Sanitary Pad Vending Machine" },
                                        { path: "/services/tissuepapers", label: "Tissue Paper" },
                                        { path: "/services/cleaningchemicals", label: "Cleaning Chemicals" },
                                        { path: "/services/housekeeping", label: "Housekeeping" },
                                        { path: "/services/stationary", label: "Stationary" },
                                        { path: "/services/plantOnRent", label: "Plant on Rent" },
                                        { path: "/services/gifting", label: "Corporate Gifting" },
                                        { path: "/services/boat", label: "Boat Accessories" },
                                        { path: "/services/snacks", label: "Ready-to-Eat Snacks" }
                                    ].map((service, index) => (
                                        <li key={index}>
                                            <Link
                                                className="dropdown-item"
                                                to={service.path}
                                                onClick={handleNavClick}
                                                style={{ color: "white" }}
                                                onMouseEnter={(e) => (e.target.style.color = "black")}
                                                onMouseLeave={(e) => (e.target.style.color = "white")}
                                            >
                                                {service.label}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link fs-18 fw-bold" to="/about" onClick={handleNavClick}>About us</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link fs-18 fw-bold" to="/contact" onClick={handleNavClick}>Contact us</Link>
                            </li>
                        </ul>
                        <span className="me-3 fw-bold" style={{ color: "rgb(52, 81, 159)" }}>
                            Call On: +91 70289 90059
                        </span>
                    </Collapse>
                </Container>
            </nav>
        </React.Fragment>
    );
};

export default Navbar;


